/* Search: live suggestions from Shopify predictive search, plus typo-tolerant (fuzzy) matching
   against the product catalogue so "capsul", "mjun" or "prolog" still find the right product. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var catalogue = null, catalogueLoading = null;

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim(); }

  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      var cur = [i], rowMin = i;
      for (j = 1; j <= b.length; j++) {
        var c = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        cur[j] = c; if (c < rowMin) rowMin = c;
      }
      if (rowMin > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  }

  /* Score one query word against one product word. Higher is better, 0 = no match. */
  function wordScore(q, w) {
    if (w === q) return 10;
    if (w.indexOf(q) === 0) return 8;
    if (q.length >= 3 && w.indexOf(q) > -1) return 6;
    if (q.length >= 3 && q.indexOf(w) === 0 && w.length >= 4) return 5;
    var max = q.length <= 4 ? 1 : (q.length <= 8 ? 2 : 3);
    if (q.length < 3) return 0;
    var d = lev(q, w, max);
    if (d <= max) return 4 - d * 0.5;
    /* typo in the tail of a longer word: compare against a same-length prefix */
    if (w.length > q.length) {
      d = lev(q, w.slice(0, q.length), max);
      if (d <= max) return 3.5 - d * 0.5;
    }
    return 0;
  }

  function score(query, p) {
    var qs = norm(query).split(' ').filter(Boolean);
    if (!qs.length) return 0;
    var title = p._t, extra = p._x, total = 0;
    for (var i = 0; i < qs.length; i++) {
      var best = 0, k;
      for (k = 0; k < title.length; k++) best = Math.max(best, wordScore(qs[i], title[k]) * 1.5);
      for (k = 0; k < extra.length; k++) best = Math.max(best, wordScore(qs[i], extra[k]));
      if (!best) return 0; /* every word must match something */
      total += best;
    }
    return total;
  }

  function loadCatalogue() {
    if (catalogue) return Promise.resolve(catalogue);
    if (catalogueLoading) return catalogueLoading;
    catalogueLoading = fetch(root + 'collections/all/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        catalogue = (j.products || []).map(function (p) {
          var prices = (p.variants || []).map(function (v) { return parseFloat(v.price); });
          return {
            title: p.title, url: root + 'products/' + p.handle,
            price: prices.length ? Math.min.apply(null, prices) : null,
            image: p.images && p.images[0] ? p.images[0].src : '',
            _t: norm(p.title).split(' '),
            _x: norm([p.product_type, p.vendor, Array.isArray(p.tags) ? p.tags.join(' ') : p.tags].join(' ')).split(' ').filter(Boolean)
          };
        });
        return catalogue;
      })
      .catch(function () { catalogue = []; return catalogue; });
    return catalogueLoading;
  }

  function fuzzy(query, limit) {
    return loadCatalogue().then(function (list) {
      return list.map(function (p) { return { p: p, s: score(query, p) }; })
        .filter(function (x) { return x.s > 0; })
        .sort(function (a, b) { return b.s - a.s; })
        .slice(0, limit || 6)
        .map(function (x) { return x.p; });
    });
  }

  function listHtml(products) {
    return '<ul class="ve-search-dialog__list">' + products.map(function (p) {
      var img = p.image ? '<img src="' + esc(p.image) + '" alt="" width="64" height="64" loading="lazy">' : '';
      var price = p.price != null && p.price !== '' ? '<span>Rs. ' + Number(p.price).toFixed(2) + '</span>' : '';
      return '<li><a href="' + esc(p.url) + '">' + img + '<span class="ve-search-dialog__name">' + esc(p.title) + '</span>' + price + '</a></li>';
    }).join('') + '</ul>';
  }

  /* ---- Search page: when Shopify finds nothing, offer close matches ---- */
  var slot = document.querySelector('[data-ve-fuzzy]');
  if (slot) {
    fuzzy(slot.getAttribute('data-ve-fuzzy'), 6).then(function (res) {
      if (!res.length) return;
      slot.innerHTML = '<p class="ve-muted">Did you mean one of these?</p>' + listHtml(res);
      slot.hidden = false;
    });
  }

  /* ---- Search dialog ---- */
  var dialog = document.getElementById('ve-search');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  var input = dialog.querySelector('.ve-search-dialog__input');
  var body = document.getElementById('ve-search-results');
  var initial = body.innerHTML;
  var timer, ctrl, seq = 0;
  var action = dialog.querySelector('form').action;

  function open(e) { if (e) e.preventDefault(); dialog.showModal(); input.focus(); loadCatalogue(); }
  function close() { dialog.close(); }
  document.querySelectorAll('[data-ve-search-open]').forEach(function (a) { a.addEventListener('click', open); });
  dialog.querySelector('[data-ve-search-close]').addEventListener('click', close);
  dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });

  function render(products, q, fuzzyUsed) {
    if (!products.length) {
      body.innerHTML = '<p class="ve-search-dialog__hint">No products found for &ldquo;' + esc(q) + '&rdquo;. Try another word, or browse a category.</p>' + initial.slice(initial.indexOf('<div class="ve-search-dialog__chips"'));
      return;
    }
    body.innerHTML = (fuzzyUsed ? '<p class="ve-search-dialog__hint">Showing close matches for &ldquo;' + esc(q) + '&rdquo;</p>' : '') +
      listHtml(products) +
      '<a class="ve-search-dialog__all" href="' + action + '?type=product&q=' + encodeURIComponent(q) + '">See all results</a>';
  }

  input.addEventListener('input', function () {
    var q = input.value.trim(), my = ++seq;
    clearTimeout(timer);
    if (ctrl) ctrl.abort();
    if (q.length < 2) { body.innerHTML = initial; return; }
    timer = setTimeout(function () {
      ctrl = new AbortController();
      var exact = fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { signal: ctrl.signal })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var list = (j.resources && j.resources.results && j.resources.results.products) || [];
          return list.map(function (p) { return { title: p.title, url: p.url, price: p.price, image: p.featured_image && p.featured_image.url }; });
        })
        .catch(function (e) { if (e.name === 'AbortError') throw e; return []; });
      exact.then(function (list) {
        if (my !== seq) return;
        if (list.length) { render(list, q, false); return; }
        return fuzzy(q, 6).then(function (f) { if (my === seq) render(f, q, f.length > 0); });
      }).catch(function () {});
    }, 180);
  });
})();
